import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { EntityBlogCategoryApi, FilterEntityBlogCategoryOptions } from 'api';

export const filterEntityBlogCategory = createAsyncThunk(
  'entityBlogCategory/filterEntityArea',
  async (option: FilterEntityBlogCategoryOptions, { rejectWithValue }) => {
    try {
      const response = await EntityBlogCategoryApi.filterAll(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntityBlogCategory = createAsyncThunk(
  'entityBlogCategory/createEntityArea',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityBlogCategoryApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneEntityBlogCategory = createAsyncThunk(
  'entityBlogCategory/findOneEntityArea',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityBlogCategoryApi.findOne(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityBlogCategory = createAsyncThunk(
  'entityBlogCategory/updateEntityArea',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntityBlogCategoryApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const sortEntityBlogCategory = createAsyncThunk(
  'entityBlogCategory/sortEntityBlogCategory',
  async (params: any, { rejectWithValue }) => {
    try {
      const { body } = params;
      const response = await EntityBlogCategoryApi.sort(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeEntityBlogCategory = createAsyncThunk(
  'entityBlogCategory/removeEntityArea',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityBlogCategoryApi.remove(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  tableList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  query: any;
  savedPagination: any;
  savedList: Array<any>;
}

const initialState: IState = {
  tableList: [],
  list: [],
  reloadFlag: false,
  query: {},
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
  savedList: [],
};

const entityBlogCategorySlice = createSlice({
  name: 'entityBlogCategory',
  initialState,
  reducers: {
    reloadEntityBlogCategory(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    updateSavedPaginationEntityBlogCategory(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListEntityBlogCategory(state, action) {
      state.savedList = action.payload;
    },
  },
  // extraReducers: builder => {},
});

const { actions, reducer: entityBlogCategoryReducer } = entityBlogCategorySlice;

export const {
  reloadEntityBlogCategory,
  updateSavedPaginationEntityBlogCategory,
  updateSavedListEntityBlogCategory,
} = actions;

export default entityBlogCategoryReducer;
